module.exports = __webpack_public_path__ + "img/album10_15.9d44fc3b.jpg";